export default "__VITE_ASSET__B4QT20VN__"